import buildQuery, { Filter, OrderBy } from "odata-query";

export { buildQuery };

export const MAX_TOP_IN_SELECT_REQ = 99;

export type ParamsFilters = Array<{ dataIndex: string; value: string | string[] | number | { gt: number } | {} }>;
export type OdataFilters = {
    preparedFilter?: {};
    customFilters?: { [x: string]: { value: string } };
    queryFilter?: string | string[][] | Record<string, string> | URLSearchParams | undefined | { [x: string]: [] };
    start?: number;
    length?: number;
    maxCount?: number;
    orderBy?: OrderBy<{}> | undefined;
    filters?: ParamsFilters;
    filter?: {};
};

export function mergeFilters(
    action: (props: {}) => void,
    { name, value }: { name: string; value: any },
    { filters }: { filters: ParamsFilters },
    isLazy = false,
) {
    if (value === "-" || value === null) {
        const newFilters = filters.filter((item) => item.dataIndex !== name);
        action && action({ filters: newFilters, ...(isLazy ? {} : { start: 0 }) });
    } else if (filters.some((item) => item.dataIndex === name)) {
        const newFilters = filters.map((item) => (item.dataIndex === name ? { ...item, value } : item));
        action && action({ filters: newFilters, ...(isLazy ? {} : { start: 0 }) });
    } else {
        filters.push({ dataIndex: name, value });
        action && action({ filters, ...(isLazy ? {} : { start: 0 }) });
    }
}

export function queryCollection(
    { start, length, orderBy, filters = [] }: OdataFilters,
    { filter = {}, ...params }: { count?: boolean; filter?: {}; orderBy?: OrderBy<{}> } = {},
    limit = true,
) {
    const formattedFilters = filters.reduce((acc, f) => Object.assign(acc, { [f.dataIndex]: f.value }), {});
    const query: { orderBy?: OrderBy<{}>; filter: Filter<{}> } = {
        filter: { ...filter, ...formattedFilters },
        ...(limit ? { top: length, skip: start } : {}),
        ...params,
    };
    if (orderBy) {
        query.orderBy = orderBy;
    }
    return buildQuery(query);
}

export function queryItem(id: string, params: {}) {
    return buildQuery({ key: id, ...params });
}

export function containsQuery(selectParams: { filters?: ParamsFilters }, filterParams: OdataFilters | undefined = {}) {
    const { filters } = selectParams;
    const { filter = {}, ...params } = filterParams;
    filters?.forEach((item) => {
        if (typeof item.value === "string") {
            item.value = encodeURIComponent(item.value.toLowerCase());
        }
    });

    const formattedFilters = filters?.length ? buildFilter(filters) : {};
    return buildQuery({ filter: { ...formattedFilters, ...filter }, top: MAX_TOP_IN_SELECT_REQ, ...params });
}

export function queryParams(params: {}) {
    const qp = new URLSearchParams(params);
    return `?${qp.toString()}`;
}

const buildFilter = ({ 0: filter }: ParamsFilters) =>
    Array.isArray(filter.dataIndex)
        ? filter.dataIndex.reduce((prev, cur) => ({ or: { ...prev.or, ...getFilter(cur, filter.value as string) } }), {
              or: {},
          })
        : getFilter(filter.dataIndex, filter.value as string);

const getFilter = (dataIndex: string, value: string) =>
    dataIndex === "id" || dataIndex === "transportColumnId"
        ? { [dataIndex]: { in: value } }
        : { [`tolower(${dataIndex})`]: { contains: { type: "raw", value: `'${value}'` } } };
